export default __webpack_public_path__ + "static/media/circleChecked.97b4d761.svg";